import _ from 'lodash'
import {
	L2TabularListRoot,
	L2TabularListHeader,
	L2TabularListContent,
} from '../l2/L2TabularList'
import {
	L2TabularListItemSummary,
} from '../l2/L2TabularListItem'

/**
 * WARNING
 * Once this goes to production, these hardcoded models cannot change without
 * discussion, because it would change the form—  and forms are supposed to
 * stay the same from a legal perspective once they start getting used for
 * real data.  Also, JSON based on them will have been recorded into the
 * database and any change may cause loads of previous data to break or render
 * incorrectly.  This will not be an issue once they are being dynamically
 * defined in the Flow XML along with everything else.
 */
export interface L3SurgicalHistoryListModel {
	Date: string,
	Procedure: string,
}

const newModel = (): L3SurgicalHistoryListModel => {
	return {
		Date: '',
		Procedure: '',
	}
}

interface L3SurgicalHistoryListProps {
	models?: L3SurgicalHistoryListModel[],
}

export const L3SurgicalHistoryList = ({models = []}: L3SurgicalHistoryListProps) => {
	const items = _.map(models, (model, modelIdx) => {
		return (
			<L2TabularListItemSummary key={modelIdx}>
				<div>{model.Date}</div>
				<div>{model.Procedure}</div>
			</L2TabularListItemSummary>
		)
	})
	return (
		<L2TabularListRoot columnCount={5}>
			<L2TabularListHeader>
				<div>Date</div>
				<div>Procedure</div>
			</L2TabularListHeader>
			<L2TabularListContent>
				{items}
			</L2TabularListContent>
		</L2TabularListRoot>
	)
}
